import axios from '@axios'

const PREFIX = '/usuarios-internos'

export default {

  getUsuariosInternos(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getUsuarioInterno(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  updateUsuarioInterno(id, usuarioInterno) {
    return axios.put(`${PREFIX}/${id}`, usuarioInterno)
  },

  createUsuarioInterno(usuarioInterno) {
    return axios.post(`${PREFIX}/add`, usuarioInterno)
  },

  deleteUsuarioInterno(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  validaCpf(id, cpf) {
    if (id) {
      return axios.get(`${PREFIX}/${id}/cpf/${cpf}`)
    }
    return axios.get(`${PREFIX}/login/${cpf}`)
  },

  validaLogin(id, login) {
    if (id) {
      return axios.get(`${PREFIX}/${id}/login/${login}`)
    }
    return axios.get(`${PREFIX}/login/${login}`)
  },

  validaSMTP(id, email, senha) {
    if (id) {
      return axios.get(`${PREFIX}/${id}/valida-smtp/${email}/${senha}`)
    }
    return axios.get(`${PREFIX}/valida-smtp/${email}/${senha}`)
  },

  getPerfil() {
    return axios.get(`${PREFIX}/perfil`)
  },

  salvarPerfil(senha) {
    return axios.put(`${PREFIX}/perfil/${senha}`)
  },

  getUsuariosResumidos(filtro, ativos) {
    return axios.post(`${PREFIX}/resumido?ativo=${ativos}`, filtro)
  },

  autenticarGoogle(id, codeResponse, emailSMTP) {
    return axios.get(`${PREFIX}/${id}/autenticar-google?code=${codeResponse}&email=${emailSMTP}`)
  },

  logOutGoogle(id) {
    return axios.get(`${PREFIX}/log-out/${id}`)
  },

  getClientGoogle() {
    return axios.get(`${PREFIX}/client`)
  },

  getUsuariosMarcacaoDocuSign() {
    return axios.get(`${PREFIX}/docusign-usuario`)
  },
}
